// import { map } from "lodash";
import { Auth } from '@/models/Auth';
import { checkRole } from '@/models/helpers/role-helper';
import User from '@/models/User';
// import UserEnrollment from "@/models/UserEnrollment";
// import { getAuth } from 'firebase/auth';

export const userInfoMixin = {
  computed: {
    cookieAuth() {
      return this.$cookies.get('user-learn4life');
    },

    token() {
      return Auth.getAppToken();
    },

    user() {
      return User.query().first();
    },

    userId() {
      return this.user ? this.user.id : null;
    },

    userRole() {
      return this.user.user_roles;
    },

    uid() {
      return this.user ? this.user.uid : null;
    },

    avatarIcon() {
      const words = this.user ? (this.user.name ? this.user.name.split(' ') : null) : null;
      if (words.length === 1) return words[0][0].toUpperCase();
      const shortName = words[0][0] + words[words.length - 1][0];

      return shortName.toUpperCase();
    }
  },

  methods: {
    // async $_userInfoMixin_loadAuthUser() {
    //   try {
    //     const token = await getAuth().currentUser.getIdToken(true);
    //     await User.api().fetchByFirebaseToken(token);
    //     User.commit((state) => (state.isFetching = true));

    //     return User.find(this.user.id);
    //   } catch (error) {
    //     User.commit((state) => (state.isFetching = true));
    //     const data = error.response?.data?.data;
    //     if (data.id === 'auth/no-user-info') {
    //       return null;
    //     } else {
    //       console.error(error);
    //       throw error;
    //     }
    //   }
    // },

    $_userInfoMixin_goToHomePagePage(user) {
      let name = 'learning-unit';

      if (user) {
        const isReviewer = checkRole(user, 'reviewer');

        if (isReviewer) {
          name = 'review-learning-unit';
        }
      }

      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    }
  }
};
